/* eslint-disable react/prop-types */
import { Component } from "react";
import { Alert, Badge, Button, Card, Col, Form, Modal, Row, Spinner, Table } from "react-bootstrap";
import Swal from "sweetalert2";
import moment from "moment-timezone";

import acompanhamentoMedicoService from "../../api/atendimentos/acompanhamentoMedicoService";
import { formataDataExibicao, formataDataHoraExibicao, frequenciasAcompanhamentoMedico, motivosCancelamentoAcompanhamentoMedico, ordenacaoAcompanhamentoMedico, ordensOrdenacaoProdutosEmUso, statusAcompanhamentoMedico} from "../../common/utils";

class AcompanhamentoMedicoAtendimento extends Component {
    constructor(props) {
        super(props);

        this.fileInputRef = null;

        this.state = {
            loading: true,
            loadingModal: false,
            error: "",
            registros: [],
            configuracao_alertas: null,
            ordenar_por: "data_proxima_consulta",
            ordem: "asc",
            showModal: false,
            modalTitulo: "Adicionar acompanhamento médico",
            registroEditando: null,
            frequencia_acompanhamento: "",
            data_ultima_consulta: "",
            data_proxima_consulta: "",
            nome_local_tratamento: "",
            status: "",
            motivo_cancelamento: "",
            motivo_cancelamento_outros: "",
            documento: null,
            documento_atual: "",
        };
    }

    componentDidMount() {
        this.carregarRegistros();
    }

    componentDidUpdate(prevProps, prevState) {
        if (
            prevProps.atendimentoId !== this.props.atendimentoId ||
            prevState.ordenar_por !== this.state.ordenar_por ||
            prevState.ordem !== this.state.ordem
        ) {
            this.carregarRegistros();
        }
    }

    // no fuso do backend (date.today() em America/Sao_Paulo): com toISOString (UTC),
    // a partir das 21h o "hoje" virava amanhã e invertia os limites dos dois campos
    getDataHoje = () => moment.tz("America/Sao_Paulo").format("YYYY-MM-DD");

    getMensagemErro = (error, fallback) => {
        const data = error?.response?.data;

        if (typeof data === "string" && data.trim()) {
            return data;
        }

        if (data && typeof data === "object") {
            const primeiraChave = Object.keys(data)[0];
            const primeiroValor = data[primeiraChave];

            if (Array.isArray(primeiroValor) && primeiroValor.length > 0) {
                return primeiroValor[0];
            }

            if (typeof primeiroValor === "string" && primeiroValor.trim()) {
                return primeiroValor;
            }
        }

        return fallback;
    };

    carregarRegistros = () => {
        const { atendimentoId } = this.props;
        const { ordenar_por, ordem } = this.state;

        if (!atendimentoId) {
            this.setState({
                registros: [],
                configuracao_alertas: null,
                loading: false,
                error: "",
            });
            return;
        }

        this.setState({ loading: true, error: "" });

        acompanhamentoMedicoService.listar(atendimentoId, ordenar_por, ordem)
            .then((response) => {
                this.setState({
                    registros: Array.isArray(response.data?.resultados) ? response.data.resultados : [],
                    configuracao_alertas: response.data?.configuracao_alertas || null,
                    loading: false,
                    error: "",
                });
            })
            .catch((error) => {
                console.error("Erro ao carregar acompanhamento médico:", error);
                this.setState({
                    loading: false,
                    error: this.getMensagemErro(error, "Erro ao carregar acompanhamento médico."),
                });
            });
    };

    limparFormulario = () => {
        this.setState({
            registroEditando: null,
            frequencia_acompanhamento: "",
            data_ultima_consulta: "",
            data_proxima_consulta: "",
            nome_local_tratamento: "",
            status: "",
            motivo_cancelamento: "",
            motivo_cancelamento_outros: "",
            documento: null,
            documento_atual: "",
        });
    };

    abrirModalNovo = () => {
        this.limparFormulario();
        this.setState({
            showModal: true,
            modalTitulo: "Adicionar acompanhamento médico",
        });
    };

    abrirModalEditar = (registro) => {
        this.setState({
            showModal: true,
            modalTitulo: `Editar acompanhamento #${registro.id}`,
            registroEditando: registro,
            frequencia_acompanhamento: registro?.frequencia_acompanhamento || "",
            data_ultima_consulta: registro?.data_ultima_consulta || "",
            data_proxima_consulta: registro?.data_proxima_consulta || "",
            nome_local_tratamento: registro?.nome_local_tratamento || "",
            status: registro?.status || "",
            motivo_cancelamento: registro?.motivo_cancelamento || "",
            motivo_cancelamento_outros: registro?.motivo_cancelamento_outros || "",
            documento: null,
            documento_atual: registro?.documento || "",
        });
    };

    fecharModal = () => {
        if (this.state.loadingModal) return;

        this.setState({ showModal: false }, () => {
            this.limparFormulario();
        });
    };

    onChangeCampo = (e) => {
        const { name, value } = e.target;

        this.setState({
            [name]: value,
        });
    };

    onChangeDocumento = (e) => {
        const arquivo = e.target.files && e.target.files[0] ? e.target.files[0] : null;
        this.setState({ documento: arquivo });
    };

    validarFormulario = () => {
        const {
            frequencia_acompanhamento,
            data_ultima_consulta,
            data_proxima_consulta,
            nome_local_tratamento,
            status,
            motivo_cancelamento,
            motivo_cancelamento_outros,
        } = this.state;

        const hoje = this.getDataHoje();

        if (!frequencia_acompanhamento || !data_ultima_consulta || !data_proxima_consulta || !String(nome_local_tratamento || "").trim()) {
            Swal.fire("Atenção", "Preencha frequência, última consulta, próxima consulta e local de acompanhamento.", "warning");
            return false;
        }

        if (!status) {
            Swal.fire("Atenção", "Selecione o status da consulta.", "warning");
            return false;
        }

        if (data_ultima_consulta > hoje) {
            Swal.fire("Atenção", "A data da última consulta não pode ser futura.", "warning");
            return false;
        }

        if (data_proxima_consulta < hoje) {
            Swal.fire("Atenção", "A data da próxima consulta não pode ser retroativa.", "warning");
            return false;
        }

        if (status === "cancelada" && !motivo_cancelamento) {
            Swal.fire("Atenção", "Informe o motivo do cancelamento.", "warning");
            return false;
        }

        if (status === "cancelada" && motivo_cancelamento === "outros" && !String(motivo_cancelamento_outros || "").trim()) {
            Swal.fire("Atenção", "Descreva o motivo do cancelamento.", "warning");
            return false;
        }

        return true;
    };

    montarPayload = () => {
        const {
            registroEditando,
            frequencia_acompanhamento,
            data_ultima_consulta,
            data_proxima_consulta,
            nome_local_tratamento,
            status,
            motivo_cancelamento,
            motivo_cancelamento_outros,
            documento,
        } = this.state;

        const { atendimentoId } = this.props;

        const usaFormData = !!documento;

        if (!usaFormData) {
            return {
                data: {
                    atendimento_id: atendimentoId,
                    frequencia_acompanhamento,
                    data_ultima_consulta,
                    data_proxima_consulta,
                    nome_local_tratamento: String(nome_local_tratamento || "").trim(),
                    status,
                    motivo_cancelamento: status === "cancelada" ? motivo_cancelamento || null : null,
                    motivo_cancelamento_outros: status === "cancelada" && motivo_cancelamento === "outros"
                        ? String(motivo_cancelamento_outros || "").trim()
                        : "",
                },
                isFormData: false,
            };
        }

        const formData = new FormData();

        if (!registroEditando) {
            formData.append("atendimento_id", atendimentoId);
        } else {
            formData.append("atendimento_id", atendimentoId);
        }

        formData.append("frequencia_acompanhamento", frequencia_acompanhamento);
        formData.append("data_ultima_consulta", data_ultima_consulta);
        formData.append("data_proxima_consulta", data_proxima_consulta);
        formData.append("nome_local_tratamento", String(nome_local_tratamento || "").trim());
        formData.append("status", status);
        formData.append("motivo_cancelamento", status === "cancelada" ? (motivo_cancelamento || "") : "");
        formData.append(
            "motivo_cancelamento_outros",
            status === "cancelada" && motivo_cancelamento === "outros"
                ? String(motivo_cancelamento_outros || "").trim()
                : ""
        );
        formData.append("documento", documento);

        return {
            data: formData,
            isFormData: true,
        };
    };

    salvarRegistro = () => {
        if (!this.validarFormulario()) {
            return;
        }

        const { registroEditando } = this.state;
        const payload = this.montarPayload();

        this.setState({ loadingModal: true });

        const request = registroEditando
            ? acompanhamentoMedicoService.update(registroEditando.id, payload.data)
            : acompanhamentoMedicoService.create(payload.data);

        request
            .then(() => {
                this.setState({ showModal: false, loadingModal: false }, async () => {
                    this.limparFormulario();
                    await this.carregarRegistros();
                });

                Swal.fire(
                    "Sucesso",
                    registroEditando ? "Acompanhamento atualizado com sucesso." : "Acompanhamento cadastrado com sucesso.",
                    "success"
                );
            })
            .catch((error) => {
                console.error("Erro ao salvar acompanhamento médico:", error);
                this.setState({ loadingModal: false });
                Swal.fire("Erro", this.getMensagemErro(error, "Erro ao salvar acompanhamento médico."), "error");
            });
    };

    renderStatusBadge = (status) => {
        const label = statusAcompanhamentoMedico[status] || status || "-";

        if (status === "realizada") return <Badge bg="success">{label}</Badge>;
        if (status === "reagendada") return <Badge bg="warning" text="dark">{label}</Badge>;
        if (status === "cancelada") return <Badge bg="danger">{label}</Badge>;

        return <Badge bg="secondary">{label}</Badge>;
    };

    renderMotivo = (registro) => {
        if (registro?.status !== "cancelada") return "-";

        const motivo = motivosCancelamentoAcompanhamentoMedico[registro?.motivo_cancelamento] || "-";

        if (registro?.motivo_cancelamento === "outros" && registro?.motivo_cancelamento_outros) {
            return `${motivo}: ${registro.motivo_cancelamento_outros}`;
        }

        return motivo;
    };

    render() {
        const { podeEditar } = this.props;
        const {
            loading,
            loadingModal,
            error,
            registros,
            configuracao_alertas,
            ordenar_por,
            ordem,
            showModal,
            modalTitulo,
            registroEditando,
            frequencia_acompanhamento,
            data_ultima_consulta,
            data_proxima_consulta,
            nome_local_tratamento,
            status,
            motivo_cancelamento,
            motivo_cancelamento_outros,
            documento_atual,
        } = this.state;

        return (
            <>
                <Card className="cardDestaque mt-4">
                    <Card.Body>
                        <Row className="align-items-center mb-3">
                            <Col sm={6} lg={6}>
                                <h6><strong>Acompanhamento Médico</strong></h6>
                            </Col>
                            {podeEditar && (
                                <Col sm={6} xs={6} className="text-end">
                                    <Button type="button" variant="success" className="btn-sm mt-3" onClick={this.abrirModalNovo}>
                                        Novo acompanhamento
                                    </Button>
                                </Col>
                            )}
                        </Row>

                        {/* só quando o envio está ligado no programa; a config vem sempre no payload */}
                        {configuracao_alertas?.enviar_whatsapp_paciente === true && (
                            <Alert variant="info">
                                Alertas automáticos configurados para este acompanhamento médico.
                            </Alert>
                        )}

                        <Row className="mb-3">
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Ordenar por</Form.Label>
                                    <Form.Select name="ordenar_por" value={ordenar_por} onChange={this.onChangeCampo}>
                                        {Object.entries(ordenacaoAcompanhamentoMedico).map(([valor, label]) => (
                                            <option key={valor} value={valor}>{label}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={4}>
                                <Form.Group>
                                    <Form.Label>Ordem</Form.Label>
                                    <Form.Select name="ordem" value={ordem} onChange={this.onChangeCampo}>
                                        {Object.entries(ordensOrdenacaoProdutosEmUso).map(([valor, label]) => (
                                            <option key={valor} value={valor}>{label}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                        </Row>

                        {error && <Alert variant="danger">{error}</Alert>}

                        {loading ? (
                            <div className="text-center py-4">
                                <Spinner animation="border" />
                            </div>
                        ) : registros.length > 0 ? (
                            <Row>
                                <Col sm={12} lg={12}>
                                    <Table responsive className="custom-table">
                                        <thead>
                                            <tr>
                                                <th>Frequência</th>
                                                <th>Última consulta</th>
                                                <th>Próxima consulta</th>
                                                <th>Local de acompanhamento</th>
                                                <th>Status</th>
                                                <th>Motivo</th>
                                                <th>Documento</th>
                                                <th>Ações</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {registros.map((registro) => (
                                                <tr key={registro.id} className={registro?.consulta_vencida ? "table-warning" : ""}>
                                                    <td><div className="td-border">{frequenciasAcompanhamentoMedico[registro?.frequencia_acompanhamento] || "-"}</div></td>
                                                    <td><div className="td-border">{registro?.data_ultima_consulta ? formataDataExibicao(registro.data_ultima_consulta) : "-"}</div></td>
                                                    <td>
                                                        <div className="td-border">
                                                            {registro?.data_proxima_consulta ? formataDataExibicao(registro.data_proxima_consulta) : "-"}
                                                            {registro?.consulta_vencida && (
                                                                <Badge bg="warning" text="dark" className="ms-2">Vencida</Badge>
                                                            )}
                                                        </div>
                                                    </td>
                                                    <td><div className="td-border">{registro?.nome_local_tratamento || "-"}</div></td>
                                                    <td><div className="td-border">{this.renderStatusBadge(registro?.status)}</div></td>
                                                    <td><div className="td-border">{this.renderMotivo(registro)}</div></td>
                                                    <td>
                                                        <div className="td-border">
                                                            {registro?.documento ? (
                                                                <a href={registro.documento} target="_blank" rel="noreferrer">Ver documento</a>
                                                            ) : "-"}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        {podeEditar ? (
                                                            <Button variant="secondary" size="sm" onClick={() => this.abrirModalEditar(registro)}>
                                                                Editar
                                                            </Button>
                                                        ) : (
                                                            <span className="text-muted">Visualização</span>
                                                        )}
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                </Col>
                            </Row>
                        ) : (
                            <p>Nenhum acompanhamento médico cadastrado até o momento</p>
                        )}
                    </Card.Body>
                </Card>

                <Modal show={showModal} onHide={this.fecharModal} size="lg">
                    <Modal.Header closeButton>
                        <Modal.Title>{modalTitulo}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Row>
                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Frequência de acompanhamento</Form.Label>
                                    <Form.Select
                                        name="frequencia_acompanhamento"
                                        value={frequencia_acompanhamento}
                                        onChange={this.onChangeCampo}
                                    >
                                        <option value="">Selecione...</option>
                                        {Object.entries(frequenciasAcompanhamentoMedico).map(([valor, label]) => (
                                            <option key={valor} value={valor}>{label}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Status</Form.Label>
                                    <Form.Select name="status" value={status} onChange={this.onChangeCampo}>
                                        <option value="">Selecione...</option>
                                        {Object.entries(statusAcompanhamentoMedico).map(([valor, label]) => (
                                            <option key={valor} value={valor}>{label}</option>
                                        ))}
                                    </Form.Select>
                                </Form.Group>
                            </Col>

                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Data da última consulta</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="data_ultima_consulta"
                                        value={data_ultima_consulta}
                                        onChange={this.onChangeCampo}
                                        max={this.getDataHoje()}
                                    />
                                </Form.Group>
                            </Col>

                            <Col sm={6} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Data da próxima consulta</Form.Label>
                                    <Form.Control
                                        type="date"
                                        name="data_proxima_consulta"
                                        value={data_proxima_consulta}
                                        onChange={this.onChangeCampo}
                                        min={this.getDataHoje()}
                                    />
                                </Form.Group>
                            </Col>

                            <Col sm={12} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Local de acompanhamento</Form.Label>
                                    <Form.Control
                                        type="text"
                                        name="nome_local_tratamento"
                                        value={nome_local_tratamento}
                                        onChange={this.onChangeCampo}
                                        maxLength={200}
                                    />
                                </Form.Group>
                            </Col>

                            {status === "cancelada" && (
                                <>
                                    <Col sm={6} xs={12}>
                                        <Form.Group className="mb-3">
                                            <Form.Label>Motivo do cancelamento</Form.Label>
                                            <Form.Select name="motivo_cancelamento" value={motivo_cancelamento} onChange={this.onChangeCampo}>
                                                <option value="">Selecione...</option>
                                                {Object.entries(motivosCancelamentoAcompanhamentoMedico).map(([valor, label]) => (
                                                    <option key={valor} value={valor}>{label}</option>
                                                ))}
                                            </Form.Select>
                                        </Form.Group>
                                    </Col>

                                    {motivo_cancelamento === "outros" && (
                                        <Col sm={6} xs={12}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Descrição complementar</Form.Label>
                                                <Form.Control
                                                    type="text"
                                                    name="motivo_cancelamento_outros"
                                                    value={motivo_cancelamento_outros}
                                                    onChange={this.onChangeCampo}
                                                />
                                            </Form.Group>
                                        </Col>
                                    )}
                                </>
                            )}

                            <Col sm={12} xs={12}>
                                <Form.Group className="mb-3">
                                    <Form.Label>Documento</Form.Label>
                                    <Form.Control
                                        type="file"
                                        onChange={this.onChangeDocumento}
                                    />
                                    {registroEditando && documento_atual && (
                                        <Form.Text>
                                            Documento atual: <a href={documento_atual} target="_blank" rel="noreferrer">visualizar</a>
                                        </Form.Text>
                                    )}
                                </Form.Group>
                            </Col>
                        </Row>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary-outline" onClick={this.fecharModal}>
                            Fechar
                        </Button>
                        <Button variant="secondary" onClick={this.salvarRegistro} disabled={loadingModal}>
                            {loadingModal ? <span className="spinner-border spinner-border-sm"></span> : (registroEditando ? "Editar acompanhamento" : "Cadastrar acompanhamento")}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}

export default AcompanhamentoMedicoAtendimento;
